'use client';

import { useEffect, useState } from 'react';

import {
    Align,
    Icon,
    IconName,
    IconSize,
    Justify,
    List,
    ListItem,
    Popover,
    PopoverArrowPosition,
    PopoverDirection,
    View,
} from '@bytel/trilogy-react';

import { getLocalVariable, setLocalVariable } from '@services/storage';

export function SmartChangePopover() {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (!getLocalVariable('smart-change-popover-closed')) {
            setIsActive(true);
        }
    }, []);

    useEffect(() => {
        if (!isActive) return;

        const filterElement = document.querySelector('[data-cy="filters"]') as HTMLElement;
        if (!filterElement) return;

        let lastScrollLeft = filterElement.scrollLeft;

        const handleScroll = () => {
            const currentScrollLeft = filterElement.scrollLeft;
            if (currentScrollLeft !== lastScrollLeft) {
                setIsActive(false);
            }
            lastScrollLeft = currentScrollLeft;
        };

        filterElement.addEventListener('scroll', handleScroll);

        return () => {
            filterElement.removeEventListener('scroll', handleScroll);
        };
    }, [isActive]);

    const handleClose = () => {
        setIsActive(false);
        setLocalVariable('smart-change-popover-closed', 'true');
    };

    if (!isActive) {
        return null;
    }

    return (
        <Popover
            trigger={<div style={{ width: '300px', marginBottom: '-18px' }} />}
            active
            direction={PopoverDirection.BOTTOM}
            arrowPosition={PopoverArrowPosition.START}
            className='smart-change-popover is-flex is-justified-self-start'
        >
            <View flexable justify={Justify.SPACE_BETWEEN} align={Align.CENTER} className='gap-medium has-text-left'>
                <List className='is-marginless is-paddingless'>
                    <ListItem>Changez dès 12 mois si vous voulez</ListItem>
                    <ListItem>Etalez votre paiement</ListItem>
                </List>
                <Icon name={IconName.TIMES} size={IconSize.SMALL} className='cursor-pointer' onClick={handleClose} />
            </View>
        </Popover>
    );
}
